export const PricingPeriodData = [
  {
    options: [
      { label: 'Fixed Date', value: 1 },
      { label: 'Floating Date', value: 2 },
      { label: 'Fixed Price', value: 3 },
    ],
  },
];

export const IncotermTypeData = [
  {
    options: [
      { label: 'FOB', value: 'FOB' },
      { label: 'CFR', value: 'CFR' },
      { label: 'DAP', value: 'DAP' },
      { label: 'CIF', value: 'CIF' },
    ],
  },
];

export const IncotermPortTypeData = [
  {
    options: [
      { label: 'Single Port', value: 'SinglePort' },
      { label: 'Multi Port', value: 'MultiPort' },
    ],
  },
];

export const IncotermMultiPortTypeData = [
  {
    options: [
      { label: '2 Port', value: '2Port' },
      { label: '3 Port', value: '3Port' },
    ],
  },
];

export const IncotermPortType = [
  {
    options: [
      {
        label: 'Single Port',
        value: { type: 'SinglePort', code: 'SP001' },
      },
      {
        label: 'Multi Port',
        value: { type: 'MultiPort', code: 'MP001' },
      },
    ],
  },
];

export const TimelineTypeData = [
  {
    options: [
      { label: 'Accepted Loading Dates', value: 'ALD' },
      { label: 'Accepted Discharged Dates', value: 'ADD' },
    ],
  },
];

export const DmutInvitationSubStatus = [
  {
    options: [
      { label: 'KKKS', value: 'KKKS' },
      { label: 'NOC', value: 'NOC' },
      { label: 'G2G', value: 'G2G' },
      { label: 'Refinery', value: 'Refinery' },
      { label: 'Trading', value: 'Trading' },
    ],
  },
];

export const ProcurementStatusData = [
  {
    options: [
      { label: 'Draft', value: 0 },
      { label: 'Submitted', value: 1 },
      { label: 'Approved', value: 2 },
      { label: 'Rejected', value: 3 },
    ],
  },
];

export const RouteTypeData = [
  {
    options: [
      { label: 'Straits', value: 'Straits' },
      { label: 'Origin', value: 'Origin' },
    ],
  },
];

export const CargoType = [
  {
    options: [
      { label: 'Full Cargo VLGC', value: 1 },
      { label: 'Half Cargo VLGC', value: 2 },
      { label: 'Semi Refrigerated', value: 3 },
    ],
  },
];

export const UoMType = [
  {
    options: [
      { label: 'ISOTANK', value: 'ISOTANK' },
      { label: 'KL', value: 'KL' },
      { label: 'MB', value: 'MB' },
      { label: 'MT', value: 'MT' },
    ],
  },
];

export const PricingUnitType = [
  {
    options: [
      { label: 'USD/KL', value: 'USD/KL' },
      { label: 'USD/MT', value: 'USD/MT' },
      { label: 'USD/BBL', value: 'USD/BBL' },
    ],
  },
];

export const PartyType = [
  {
    options: [
      { label: 'Buyer Option', value: 'Buyer Option' },
      { label: 'Seller Option', value: 'Seller Option' },
    ],
  },
];
